const CalendarMixin = {
  methods: {
    onDepartureDateFocused() {
      if (this.deviceType === 'mobile') {
        this.$refs.departureDate.blurInput()
      }
      this.$store.commit('eHorizonSearchForm/calendar/openDepartureCalendar')
    },
    onReturnDateFocused() {
      if (this.deviceType === 'mobile') {
        this.$refs.returnDate.blurInput()
      }
      this.$store.commit('eHorizonSearchForm/calendar/openReturnCalendar')
    },
    onCalendarClosed() {
      this.$store.commit('eHorizonSearchForm/calendar/closeCalendar')
    },
    onCalendarClickedOutside() {
      if (this.deviceType !== 'mobile') {
        const refDepartureDate = this.$refs.departureDate
        if (!refDepartureDate.hasFocus() && this.calendar.type === 'departure') {
          this.$store.commit('eHorizonSearchForm/calendar/closeCalendar')
        }

        if (['return', 'multi'].includes(this.tripType)) {
          const refReturnDate = this.$refs.returnDate
          if (!refReturnDate.hasFocus() && this.calendar.type === 'return') {
            this.$store.commit('eHorizonSearchForm/calendar/closeCalendar')
          }
        }
      }
    },
    onCalendarMinDatePicked(newDate, monthStartDate) {
      if (['return', 'multi'].includes(this.tripType)) {
        this.$store.commit(
          'eHorizonSearchForm/calendar/setAutoOpenedDate',
          monthStartDate
        )
        this.$store.commit('eHorizonSearchForm/calendar/openReturnCalendar')
        if (newDate > this.$refs.returnDate.value && this.$refs.returnDate.value !== '') {
          this.$store.dispatch('groupBooking/step1/calendar/updateReturnDate', '')
        }
        if (this.deviceType !== 'mobile') {
          this.$store.commit(
            'eHorizonSearchForm/calendar/setAutoOpenedDate',
            monthStartDate
          )
          this.$store.commit('eHorizonSearchForm/calendar/openReturnCalendar')
          this.$refs.returnDate.$refs.input.focus()
        } else {
          this.$store.commit('eHorizonSearchForm/calendar/closeCalendar')
        }
      } else {
        this.$store.commit('eHorizonSearchForm/calendar/closeCalendar')
      }
      this.$store.dispatch('eHorizonSearchForm/calendar/updateDepartureDate', newDate)
    },
    onMinDateChanged(newDate) {
      this.$store.dispatch('eHorizonSearchForm/calendar/updateDepartureText', newDate)
    },
    onCalendarMaxDatePicked(newDate) {
      if (newDate === '' || newDate < this.$refs.departureDate.value) {
        this.$store.dispatch('eHorizonSearchForm/calendar/updateReturnDate', '')
        // since CALENDAR_UPDATE_RETURN_DATE is not always updating DOM,
        // we need to clear field directly
        if (this.$refs.returnDate) {
          this.$refs.returnDate.$refs.input.value = ''
        }
      } else {
        this.$store.commit('eHorizonSearchForm/calendar/closeCalendar')
        this.$store.dispatch('eHorizonSearchForm/calendar/updateReturnDate', newDate)
      }
    },
    onMaxDateChanged(newDate) {
      this.$store.dispatch('eHorizonSearchForm/calendar/updateReturnText', newDate)
    }
  },
  created() {
    this.$store.dispatch('eHorizonSearchForm/calendar/setTripType', this.tripType)
  },
  watch: {
    tripType(val) {
      this.$store.dispatch('eHorizonSearchForm/calendar/setTripType', this.tripType)
      if (val === 'oneway') {
        this.$store.dispatch('eHorizonSearchForm/calendar/updateReturnDate', '')
      }
    }
  }
}

export default CalendarMixin
